export default class ObjectTool{
    static getPropertyOfObjectsArray(objectsArray, propName){
        let results = objectsArray.map( (object )=>{
            return object[propName];
        });
        return results;
    }
}